/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Made by Mateusz Janeczek
 */

import React from 'react';
import { Glyphicon } from 'react-bootstrap';
import styles from './TrapezoidMenu.scss';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

class TabTrapezoid extends React.Component {
  render() {
    let tabActive;
    if (this.props.displayModal === this.props.tabKey && this.props.showModal) {
      tabActive =  "rightSidebar-button horizontalCenter hide-button" 
    } else if (this.props.displayModal === this.props.tabKey) {
      tabActive = "rightSidebar-button horizontalCenter "
    } else {
      tabActive = "rightSidebar-button horizontalCenter"
    }
    
    return (
      <div onClick={() => this.props.onClickTab(this.props.tabKey)} className={tabActive}>
        <div className="rightSidebar-button-text">{this.props.title}</div>
      </div>
    );
  }
}


export default withStyles(styles)(TabTrapezoid);



// WEBPACK FOOTER //
// src/components/TrapezoidMenu/TabTrapezoid.js